import React, { PureComponent } from 'react';
import { Select } from '../../../../components/ui/forms';

export default class CountrySelect extends PureComponent {
  render() {
    return (
      <Select {...this.props}><option value="">---</option><option value="AR">Argentina</option><option value="AV">Aruba</option><option value="BO">Bolivia</option><option value="CL">Chile</option><option value="CO">Colombia</option><option value="CR">Costa Rica</option><option value="DO">República Dominicana</option><option value="EC">Ecuador</option><option value="ES">España</option><option value="GT">Guatemala</option><option value="HN">Honduras</option><option value="MX">México</option><option value="NI">Nicaragua</option><option value="PA">Panamá</option><option value="PE">Perú</option><option value="PY">Paraguay</option><option value="SV">El Salvador</option><option value="US">Estados Unidos</option><option value="UY">Uruguay</option><option value="VE">Venezuela</option></Select>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Contact/ContactForm/CountrySelect/index.js